// Mirrors backend RESUME_CSS in /app/backend/server.py.
// Keep these in sync — both PDF download and live preview render from this.
export const RESUME_CSS = `
.resume-doc { font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 9.5pt; color: #000; line-height: 1.4; padding: 53px 60px; box-sizing: border-box; background: #fff; width: 100%; height: 100%; }
.resume-doc h1 { font-size: 22pt; margin: 0 0 2px; font-weight: 800; letter-spacing: -0.02em; color: #000; }
.resume-doc .contact { font-size: 8.5pt; color: #444; margin: 0 0 10px; padding-bottom: 8px; border-bottom: 2px solid #000; }
.resume-doc h2 { font-size: 10pt; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid #000; padding-bottom: 2px; margin: 12px 0 6px; color: #000; }
.resume-doc .section { margin-bottom: 8px; }
.resume-doc .entry { margin-bottom: 7px; }
.resume-doc .entry-header { display: flex; justify-content: space-between; align-items: baseline; }
.resume-doc .entry-header strong { font-size: 9.5pt; font-weight: 700; color: #000; }
.resume-doc .entry-header span { font-size: 8.5pt; color: #555; }
.resume-doc .company { font-size: 9pt; color: #555; margin: 1px 0 3px; font-style: italic; }
.resume-doc .tech { font-size: 8.5pt; color: #555; font-style: italic; margin: 2px 0 0; }
.resume-doc ul { margin: 2px 0; padding-left: 16px; }
.resume-doc li { margin-bottom: 2px; font-size: 9.25pt; line-height: 1.35; }
.resume-doc p { margin: 1px 0; }
`;

const escape = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

function workSection(work) {
  if (!work?.length) return '';
  const items = work.map((w) => {
    const bullets = (w.bullets || []).map((b) => `<li>${escape(b)}</li>`).join('');
    return `<div class="entry"><div class="entry-header"><strong>${escape(w.title)}</strong><span>${escape(w.startDate)} - ${escape(w.endDate)}</span></div><p class="company">${escape(w.company)}</p><ul>${bullets}</ul></div>`;
  }).join('');
  return `<div class="section"><h2>Work Experience</h2>${items}</div>`;
}

function educationSection(edu) {
  if (!edu?.length) return '';
  const items = edu.map((e) => {
    const gpa = e.gpa ? `<p>GPA: ${escape(e.gpa)}</p>` : '';
    return `<div class="entry"><div class="entry-header"><strong>${escape(e.degree)}</strong><span>${escape(e.year)}</span></div><p class="company">${escape(e.institution)}</p>${gpa}</div>`;
  }).join('');
  return `<div class="section"><h2>Education</h2>${items}</div>`;
}

function skillsSection(s) {
  if (!s) return '';
  const parts = [];
  for (const [key, label] of [['technical', 'Technical'], ['soft', 'Soft Skills'], ['languages', 'Languages']]) {
    if (s[key]?.length) parts.push(`<p><strong>${label}:</strong> ${s[key].map(escape).join(', ')}</p>`);
  }
  if (!parts.length) return '';
  return `<div class="section"><h2>Skills</h2>${parts.join('')}</div>`;
}

function projectsSection(projects) {
  if (!projects?.length) return '';
  const items = projects.map((p) => {
    const tech = p.techStack ? `<p class="tech">Tech: ${escape(p.techStack)}</p>` : '';
    return `<div class="entry"><strong>${escape(p.title)}</strong><p>${escape(p.description)}</p>${tech}</div>`;
  }).join('');
  return `<div class="section"><h2>Projects</h2>${items}</div>`;
}

function certificationsSection(certs) {
  if (!certs?.length) return '';
  const items = certs.map((c) => `<p><strong>${escape(c.name)}</strong> - ${escape(c.issuer)}, ${escape(c.year)}</p>`).join('');
  return `<div class="section"><h2>Certifications</h2>${items}</div>`;
}

export function buildResumeHTML({ personalInfo = {}, professionalSummary, workExperience, education, skills, projects, certifications }) {
  const contact = [personalInfo.email, personalInfo.phone, personalInfo.location, personalInfo.linkedin]
    .filter(Boolean).map(escape).join(' | ');
  const sections = [];
  if (professionalSummary) sections.push(`<div class="section"><h2>Professional Summary</h2><p>${escape(professionalSummary)}</p></div>`);
  sections.push(workSection(workExperience));
  sections.push(educationSection(education));
  sections.push(skillsSection(skills));
  sections.push(projectsSection(projects));
  sections.push(certificationsSection(certifications));

  return `<div class="resume-doc"><h1>${escape(personalInfo.name) || 'Your Name'}</h1><div class="contact">${contact}</div>${sections.join('')}</div>`;
}
